import { PolIcon } from "components/PolIcon/policon";
import React from 'react';
import { Link } from "react-router-dom";
import { resolveRouteComponent } from "v4/features/front/navigation/utils/navigation.mapper";
import { isMatching } from "v4/features/front/navigation/utils/navigation.utils";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import { usePolTranslation } from "v4/hooks/usePolTranslation";

export default function SecondaryNavigationItem({ item, currentRoute }) {
    const { t } = usePolTranslation();
    const isActive = isMatching(item, currentRoute.route);
    const itemRouteConfig = resolveRouteComponent(item);

    // Handle Submenus (Groups)
    if (item.children && item.children.length > 0) {
        const hasActiveChild = item.children.some(child => isMatching(child, currentRoute.route));

        return (
            <li className={`group ${itemRouteConfig?.className ?? ''} ${hasActiveChild ? 'active' : ''}`}>
                <span className="group-label">{t(item.label)}</span>
                <ul className="sub-menu">
                    {item.children.map(child => (
                        <SecondaryNavigationItem
                            key={child.url}
                            item={child}
                            currentRoute={currentRoute}
                        />
                    ))}
                </ul>
            </li>
        );
    }

    return (
        <li className={`${itemRouteConfig?.className ?? ''} ${!item.native_identifier ? `tab-${item.search_type}` : ''} ${isActive ? 'active' : ''}`}>
            <Link to={`/${resolveUrl(item.url, { prospect: currentRoute.params.prospect })}`}>
                <PolIcon icon={item.icon}/>
                <span>{item.label}</span>
            </Link>
        </li>
    );
}
